import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface PendingApprovalParams {
    routeId: string;
    approvalTypeId: string;
    roleId: string;
}

const initialState: PendingApprovalParams = {
    routeId: '',
    approvalTypeId: '', 
    roleId: '',
}


export const PendingApprovalParamsSllice = createSlice({
    name: 'updatePendingApprovalParams',
    initialState,
    reducers: {
        updateParams: (state, action: PayloadAction<PendingApprovalParams>) => {
            state.approvalTypeId = action.payload.approvalTypeId;
            state.routeId = action.payload.routeId;
            state.roleId = action.payload.roleId;
        }
    }
});


export const {updateParams} = PendingApprovalParamsSllice.actions;

export default PendingApprovalParamsSllice.reducer;